import { render, staticRenderFns } from "./editPlan.vue?vue&type=template&id=caff3ffa&scoped=true&"
import script from "./editPlan.vue?vue&type=script&lang=js&"
export * from "./editPlan.vue?vue&type=script&lang=js&"
import style0 from "./editPlan.vue?vue&type=style&index=0&id=caff3ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff3ffa",
  null
  
)

export default component.exports